import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '../src/views/homepage/Homepage'
import ProductDetail from '../src/views/product_detail/ProductDetail'
import WishlistContainer from '../src/views/user/WishlistContainer'
import Portfolio from '../src/views/portfolio/index.vue'
import Address from '../src/views/address/index.vue'
import Checkout from '../src/views/checkout/index.vue'
import PageNotFound from '../src/views/PageNotFound'


Vue.use(Router)

export default new Router({
  mode: 'history', // removes hashbang from url
  routes: [
    {
      path: '/',
      name: 'homepage-component',
      component: Homepage,
      meta: {
        title: 'فست فود',
        metaTags: [
          {
            name: 'description',
            content: 'فست فود'
          },
          {
            property: 'og:description',
            content: 'فست فود'
          }
        ]
      }
    },
    {
      path: '/product-detail/:id',
      name: 'product-detail-component',
      props: true,
      component: ProductDetail
    },

    {
      path: '/product',
      name: 'product',
      props: true,
      component: Portfolio
    },

    {
      path: '/address',
      name: 'address',
      props: true,
      component: Address,
      meta: {
        requiresAuth: true,
        title: 'فست فود',
        metaTags: [
          {
            name: 'description',
            content: 'فست فود'
          },
          {
            property: 'og:description',
            content: 'فست فود'
          }
        ]
      }
    },

    {
      path: '/Checkout',
      name: 'Checkout-component',
      component: Checkout
    },

    {
      path: '/wishlist',
      name: 'wishlist-container-component',
      component: WishlistContainer
    },

    { path: "*", component: PageNotFound }
  ]
})
